import React from 'react';
import { HandoffFlowVisualization } from './HandoffFlowVisualization';

interface ComprehensiveEvaluationViewProps {
  parsedArtifact: any;
}

export const ComprehensiveEvaluationView: React.FC<ComprehensiveEvaluationViewProps> = ({
  parsedArtifact,
}) => {
  if (!parsedArtifact) {
    return (
      <div className="p-8 text-center text-gray-500">
        <p>No evaluation data available.</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <HandoffFlowVisualization
        handoffFlow={parsedArtifact.handoffFlow || []}
        assistantChain={parsedArtifact.assistantChain || []}
      />
    </div>
  );
};
